import { useQuery } from 'react-query';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { ApiResponse } from '../../../interfaces/apiResponse.type';
import { SuggestionInterface } from '../../../interfaces/suggestion.interface';
import { appendQueryParamIfNotEmpty } from '../../../constants/hookConstants';

export const SUGGESTIONS_QUERY_KEY = 'suggestions';

export const useGetSuggestions = (
  from?: string,
  to?: string,
  trackingSourceId?: number | null,
  enabled = true,
) => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'from', from ?? '');
  appendQueryParamIfNotEmpty(queryParams, 'to', to ?? '');
  appendQueryParamIfNotEmpty(queryParams, 'trackingSourceId', trackingSourceId ?? '');

  return useQuery(
    [SUGGESTIONS_QUERY_KEY, from, to, trackingSourceId],
    () => dataFetch
      .get<ApiResponse<SuggestionInterface[]>['data']>(`${CORE_API_SUFFIX}suggestions?${queryParams}`)
      .then((res) => res.data),
    {
      enabled,
    },
  );
};
